/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-10-28 20:36:11
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-10-31 18:10:37
 * @FilePath: /designcenter/src/utils/analytics.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 声明全局类型
declare global {
  interface Window {
    dataLayer: any[]
    gtag?: (...args: any[]) => void
  }
}

export const trackEvent = (eventData: {
  event?: string
  eventCategory: string
  eventAction: string
  eventLabel?: string
  nonInteraction?: boolean
}) => {
  if (import.meta.env.MODE !== 'production') {
    return
  }
  try {
    // 确保 dataLayer 存在
    if (typeof window !== 'undefined') {
      if (!window.dataLayer) {
        window.dataLayer = []
      }

      window.dataLayer.push({
        event: 'uaEvent',
        nonInteraction: false,
        ...eventData,
      })

      console.log('Analytics event tracked:', eventData)
    }
  } catch (error) {
    console.error('Failed to track analytics event:', error)
  }
}

// 页面停留时长统计
export class PageTimeTracker {
  private startTime: number = 0
  private totalTime: number = 0
  private isActive: boolean = true
  private pageName: string = ''
  private hasTracked: boolean = false
  private reportTimer: number | null = null
  constructor(pageName: string) {
    this.pageName = pageName
    this.startTime = Date.now()
    this.bindEvents()
    this.startPeriodicReport()
  }

  private startPeriodicReport() {
    // 每30秒上报一次当前停留时长
    this.reportTimer = window.setInterval(() => {
      this.reportCurrentTime()
    }, 30000)
  }
  private reportCurrentTime() {
    const currentTime = this.getCurrentTime()
    const timeInSeconds = Math.round(currentTime / 1000)

    if (timeInSeconds > 0) {
      console.log('Reporting time:', timeInSeconds) // 调试用
      trackEvent({
        eventCategory: 'design_center',
        eventAction: 'stay_duration',
        eventLabel: 'design_center_MainPage',
        duration_seconds: timeInSeconds,
      })
    }
  }

  private getCurrentTime(): number {
    let time = this.totalTime
    if (this.isActive) {
      time += Date.now() - this.startTime
    }
    return time
  }

  private bindEvents() {
    // 页面可见性变化
    document.addEventListener('visibilitychange', this.handleVisibilityChange)

    // 窗口焦点变化
    // window.addEventListener('blur', this.handleBlur)
    // window.addEventListener('focus', this.handleFocus)

    // 页面卸载
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  }

  private handleVisibilityChange = () => {
    if (document.hidden) {
      this.pauseTracking()
    } else {
      this.resumeTracking()
    }
  }

  private handleBlur = () => {
    this.pauseTracking()
  }

  private handleFocus = () => {
    this.resumeTracking()
  }

  private handleBeforeUnload = () => {
    this.stopTracking()
  }

  private pauseTracking() {
    if (this.isActive) {
      this.totalTime += Date.now() - this.startTime
      this.isActive = false
    }
  }

  private resumeTracking() {
    if (!this.isActive) {
      this.startTime = Date.now()
      this.isActive = true
    }
  }

  private stopTracking() {
    if (this.hasTracked) return
    if (this.isActive) {
      this.totalTime += Date.now() - this.startTime
    }

    const timeInSeconds = Math.round(this.totalTime / 1000)
    console.log('Total time tracked:', timeInSeconds, 'seconds')
    if (timeInSeconds > 0) {
      trackEvent({
        eventCategory: 'design_center',
        eventAction: 'stay_duration',
        eventLabel: 'design_center_MainPage',
        duration_seconds: timeInSeconds,
      })
      this.hasTracked = true
    }
  }

  public destroy() {
    if (this.reportTimer) {
      clearInterval(this.reportTimer)
    }
    this.reportCurrentTime()
    // this.stopTracking()
    // document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    // window.removeEventListener('blur', this.handleBlur)
    // window.removeEventListener('focus', this.handleFocus)
    // window.removeEventListener('beforeunload', this.handleBeforeUnload)
  }
}

// 使用方法
export const createPageTracker = (pageName: string) => {
  return new PageTimeTracker(pageName)
}
